export default class Quote {
  constructor(quoteData) {
    this.quoteData = quoteData;
  }

  unquotedParts() {
    return this._collectParts('parts_unquoted');
  }

  quotedParts() {
    return this._collectParts('parts_included');
  }

  _collectParts(partKey) {
    const quoteItems = this.quoteData.quote_items;
    const parts = [];
    for (let key in quoteItems) {
      let itemData = quoteItems[key];
      itemData[partKey].forEach((part) => parts.push(part));
    }
    return parts;
  }
}
